/**
 *
 * @param {string} value string with html tags
 * @returns {string} string without html tags
 */
export function clearHtmlTags(value) {
  return new DOMParser().parseFromString(value, 'text/html').body.textContent;
}
